import { Injectable, Pipe, PipeTransform } from '@angular/core';
import {isArray} from "util";

@Pipe({
 name: 'userSearch'
})

@Injectable()
export class userSearchPipe implements PipeTransform {
 transform(users: any[], field: string, value: any): any[] {
   if (!users) return [];
   if(value.length <= 0){
     return users;
   }
   var inputVal = value.split(' ');
   var filteredArray = [];
   for(let user of users) {
     if(!user.firstName && user.name) {
       user.firstName = user.name;
     }
     if(!user.lastName && user.name) {
       user.lastName = user.name;
     }
     if((user.firstName.toLowerCase().includes(inputVal[0].toLowerCase()) || user.lastName.toLowerCase().includes(inputVal[0].toLowerCase()) || (inputVal[1] && inputVal[1] !== '' && (user.lastName.toLowerCase().includes(inputVal[1].toLowerCase()) || user.firstName.toLowerCase().includes(inputVal[1].toLowerCase()))))) {
       filteredArray.push(user);
     }
   }
   return filteredArray;
 }

 transformGroup(groups: any[], field: string, value: string): any[] {
   if (!groups) return [];
   if(value==''){
     return groups;
   }
   return groups.filter(group => ( group.name.toLowerCase().indexOf(value.toLowerCase()) !== -1));
 }
}
